export default "__VITE_ASSET__b941fb44__$_?nuxt_component=async&nuxt_component_name=SvgoFloorplanGroundFloor__"